import { CommonModule } from '@angular/common';
import { Component, OnInit, effect, inject, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { SortByModel } from 'src/app/features/handball/video-quering/model/sort-by-model';
import { SelectorModel } from 'src/app/fragments/selector/selector-model';
import { SelectorComponent } from 'src/app/fragments/selector/selector.component';
import { VideoSearchSortBy } from "@solverml/api";
import { AnalysisStore } from 'src/app/pages/analysis/store/analysis.store';

@Component({
  selector: 'app-video-sort-by',
  templateUrl: 'video-sort-by.component.html',
  styleUrls: ['video-sort-by.component.scss'],
  standalone: true,
  imports: [
    CommonModule, FormsModule, MatIcon,
    SelectorComponent
  ],
})
export class VideoSortByComponent implements OnInit {

  readonly onSortByApplied = output<void>();

  readonly store = inject(AnalysisStore);

  sortCriteria: SortByModel = {
    field: '',
    order: 'ASC',
  };

  selectedField: SelectorModel | null | undefined = null;
  fieldOptions: SelectorModel[] = [
    {
      id: '-',
      label: 'Título',
      value: "title",
    },
    {
      id: 'description',
      label: 'Descripción',
      value: "description",
    },
    {
      id: 'date',
      label: 'Fecha',
      value: "date",
    },
    {
      id: 'duration_in_seconds',
      label: 'Duración',
      value: "duration_in_seconds",
    }
  ];

  selectedCriteria: SelectorModel | null | undefined = null;
  criteriaOptions: SelectorModel[] = [
    {
      id: 'ASC',
      label: 'Ascendente (de menor a mayor)',
      value: "ASC",
    },
    {
      id: 'DESC',
      label: 'Descendente (de mayor a menor)',
      value: "DESC",
    }
  ];

  constructor() {
    effect(() => {
      const currentSort = this.store.sortBy();
      this.hydrateSort(currentSort);
    });
  }

  ngOnInit() {
  }

  private hydrateSort(storeSortBy: VideoSearchSortBy[] | null) {
    if (storeSortBy && storeSortBy.length > 0) {
      const sort = storeSortBy[0];
      this.selectedField = this.getOption(sort.field, this.fieldOptions);
      this.selectedCriteria = this.getOption(sort.order, this.criteriaOptions);
    } else {
      this.selectedField = null;
      this.selectedCriteria = null;
    }
  }

  applySortCriteria() {
    if (this.selectedField?.value && this.selectedCriteria?.value) {
      const apiSortBy: VideoSearchSortBy = {
        field: this.selectedField.value as VideoSearchSortBy.FieldEnum,
        order: this.selectedCriteria.value as VideoSearchSortBy.OrderEnum
      };

      this.store.applySortBy([apiSortBy]);
      this.onSortByApplied.emit();

    } else {
      this.store.applySortBy(null);
      this.onSortByApplied.emit();
    }
  }

  resetSortingCriteria() {
    this.selectedField = null;
    this.selectedCriteria = null;
    this.applySortCriteria();
  }

  isSortByApplied() {
    return !!(this.selectedField?.value && this.selectedCriteria?.value);
  }

  protected getOption(value: string, options: SelectorModel[]): SelectorModel | undefined {
    return options.find(option => option.value === value);
  }

  protected validateSortCriteria(value: string): "ASC" | "DESC" | "" {
    if (value === "ASC" || value === "DESC") {
      return value;
    }
    return "";
  }
}
